export const AUTH_TOKEN = 'sentry-a-token';
export const RENEWAL_TOKEN = 'sentry-a-r-token';
export const VUEX_STORE = 'sentry-p-a';
export const INCLUDE_KEYS = [];
